import { useFormContext } from "react-hook-form";
import useToastMessage from "repoV2/components/common/Toast/useToastMessage";
import { IMultipleUsersHelpers } from "repoV2/features/Common/modules/FormData/interfaces/MultipleUserHelpers.interfaces";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import {
    getSelectedSessionDetailsFieldName,
    useSessionDetailsFormGroup,
} from "../../SessionDetailsFormGroup/SessionDetailsFormGroup.utils";

const useAddNewUserDetails = () => {
    const { listingUuid, listingType } = useCheckoutBasicDetailsContext();
    const { getValues } = useFormContext();
    const { notify, toast_type_keys } = useToastMessage();
    const { classes, maxSpots } = useSessionDetailsFormGroup();

    const checkIsNewBatchValid = ({
        allUserIds,
    }: {
        allUserIds: IMultipleUsersHelpers["allUserIds"];
    }) => {
        // Current selected batch, if any
        const batches =
            getValues(
                getSelectedSessionDetailsFieldName({
                    listingUuid,
                    listingType,
                })
            ) || {};
        // incase no selected batch, we do not allow the user to add the details of another
        // user, until a batch is selected first
        if (
            (Array.isArray(batches) && !batches?.length) ||
            !Object.keys(batches)
        ) {
            notify("Please select a batch first!", {
                type: toast_type_keys.error,
            });
            return false;
        }

        // incase the batch is selected, then we see the count of spots already filled in it
        const spotsFilledInSelectedBatch =
            classes.find(classItem => classItem.uuid === batches?.value)
                ?.slotsFilled || 0;

        // max spots is the total spots that the batch can have, and if the number of users and spots already filled, plus one
        // (one for the user about to be entered), is more than this max spots, we give the error that maximum capacity reached for the batch
        if (
            maxSpots &&
            allUserIds.length + spotsFilledInSelectedBatch + 1 > maxSpots
        ) {
            notify("Maximum capacity for batch reached!", {
                type: toast_type_keys.error,
            });
            return false;
        }
        return true;
    };

    return {
        checkIsNewBatchValid,
    };
};

export default useAddNewUserDetails;
